// extracted by mini-css-extract-plugin
export default {"spinner":"RegionLoader_spinner__3jKmj"};